function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("line", {
  className: "external-link_svg__external-link_svg__st0",
  x1: 5.9,
  y1: 34.1,
  x2: 34.1,
  y2: 5.9,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("polyline", {
  className: "external-link_svg__external-link_svg__st0",
  points: "34.1,24.9 34.1,5.9 15.1,5.9 ",
  fill: "none",
  stroke: "#000000",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgExternalLink;